import React from 'react';
import { classes } from '../../../lib';
import { Orb, OrbProps } from '../Orb';
import Styles from './CallToAction.module.less';
import { MediaThumbnail } from '../../MediaThumbnail';

export type CallToActionProps = {
    color: OrbProps['color'];
    title: string;
    content: React.ReactNode;
    poster?: string;
    children: React.ReactNode;
    link: React.ReactNode;
    subText: string;
    contentType?: 'video' | 'image' | 'other';
};

export const Checklist = ({
    children,
}: {
    children: React.ReactNode;
}): JSX.Element => {
    return (
        <div
            className={classes(
                'vertical stretch-middle alude-gray-8 g40',
                Styles.checklist
            )}>
            {children}
        </div>
    );
};

export const CallToAction = ({
    title,
    content,
    poster,
    color,
    children,
    link,
    contentType = 'other',
    subText,
}: CallToActionProps): JSX.Element => {
    return (
        <Orb
            color={color}
            className="lp-section d-horizontal d-stretch-middle mt-vertical mt-stretch-top g40 td-px80 m-px40 td-py40 m-py20 semilarge-alude">
            <div className="vertical stretch-top g32 flex">
                <div className="vertical stretch-top g16">
                    <span className="h3-alude alude-gray-8">{title}</span>
                    {children}
                </div>
                <div className="vertical left-top g16">
                    {link}
                    <span className="secondary-text">{subText}</span>
                </div>
            </div>
            <MediaThumbnail
                className={classes(Styles.content, Styles[contentType])}
                content={content}
                contentType={contentType}
                poster={poster}
            />
        </Orb>
    );
};
